import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const ProductDetailsFeaturedBullets: React.FC<Props> = ({ product }) => {
    const featuredBullets = product.properties.featuredBullets;

    return (
        <div data-test-selector="productDetails_featuredBullets">
            {featuredBullets && featuredBullets.split('\n').map((b, index) => (
                <li key={index}>{b}</li>
            ))}
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsFeaturedBullets),
    definition: {
        displayName: "Feature Bullets",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
